export default  {
  backend_base: 'https://backend.intranet.veyu.ch/',
};
